var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"zxzt_item"},[_c('router-link',{attrs:{"to":("/zxzt_detail?id=" + (_vm.objItem.id)),"target":"_blank"}},[_c('img',{attrs:{"src":_vm.objItem.coverPath}}),_c('p',[_vm._v(_vm._s(_vm.objItem.name))])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }